module.exports = __webpack_public_path__ + "img/news-active.cad0b44d.svg";